<template>
    <div>
        <div>
            <app-tabela
                :itens="contrato.dotacoesOrcamentarias"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
            </app-tabela>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            dotacao: null,
            campos: [
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'projeto',
                    label: 'Projeto',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acao',
                    label: 'Ação',
                    filterable: true,
                    sortable: true
                }
            ],
            itensPorPagina: 10
        }
    }
}
</script>
